import { render, staticRenderFns } from "./BoardGroups.vue?vue&type=template&id=ee1d7cc4&scoped=true&"
import script from "./BoardGroups.vue?vue&type=script&lang=js&"
export * from "./BoardGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1d7cc4",
  null
  
)

export default component.exports